<template>  
  <myHeader />  
</template>

 
<script> 
import       myHeader from '@/components/header.vue' ;

export default {
  name: 'App',  
  components: {
    myHeader
  },    
}
</script>


<style scoped>  
</style> 